import { render, staticRenderFns } from "./mechanical-engineering-1.vue?vue&type=template&id=42473e11&scoped=true&"
import script from "./mechanical-engineering-1.vue?vue&type=script&lang=js&"
export * from "./mechanical-engineering-1.vue?vue&type=script&lang=js&"
import style0 from "./mechanical-engineering-1.vue?vue&type=style&index=0&id=42473e11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42473e11",
  null
  
)

export default component.exports